import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4877606"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-2 flex flex-row items-center" }
const _hoisted_2 = { class: "text-left font-bold text-2xl mb-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1))
const _hoisted_4 = { class: "flex w-72 mr-3" }
const _hoisted_5 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_6 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2"
}
const _hoisted_7 = {
  key: 4,
  class: "mx-10 my-10"
}
const _hoisted_8 = {
  key: 5,
  class: "mx-10 my-10"
}
const _hoisted_9 = {
  key: 6,
  class: "mx-10 my-10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_litepie_datepicker = _resolveComponent("litepie-datepicker")!
  const _component_ProjectCreationModal = _resolveComponent("ProjectCreationModal")!
  const _component_TeamCreationModal = _resolveComponent("TeamCreationModal")!
  const _component_ScoreCard = _resolveComponent("ScoreCard")!
  const _component_TeamChannelDeletionModal = _resolveComponent("TeamChannelDeletionModal")!
  const _component_ProjectsList = _resolveComponent("ProjectsList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_2, " All " + _toDisplayString(_ctx.viewOption == 'teams' ? 'Teams' : 'Projects'), 1),
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = () => _ctx.switchTo('teams')),
          class: _normalizeClass(['primary-button', 'mr-3', { 'active-switcher': _ctx.viewOption == 'projects' }])
        }, " Teams ", 2),
        false
          ? (_openBlock(), _createBlock(_component_LoadingButton, {
              key: 0,
              class: _normalizeClass(['primary-button', { 'active-switcher': _ctx.viewOption == 'teams' }]),
              onClick: _cache[1] || (_cache[1] = () => _ctx.switchTo('projects')),
              loading: _ctx.isLoadingProjects,
              disabled: _ctx.isLoadingProjects
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Projects ")
              ]),
              _: 1
            }, 8, ["class", "loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_litepie_datepicker, {
          placeholder: "Select date range",
          formatter: { date: 'YYYY-MM-DD', month: 'MMM' },
          modelValue: _ctx.dateValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dateValue) = $event))
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.viewOption == 'projects')
        ? (_openBlock(), _createBlock(_component_ProjectCreationModal, {
            key: 0,
            hasProjects: _ctx.projects.length != 0,
            class: "mr-3"
          }, null, 8, ["hasProjects"]))
        : _createCommentVNode("", true),
      (_ctx.viewOption == 'teams')
        ? (_openBlock(), _createBlock(_component_TeamCreationModal, {
            key: 1,
            hasTeams: _ctx.entries.length != 0
          }, null, 8, ["hasTeams"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true),
    (_ctx.viewOption == 'teams')
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (e) => {
            return (_openBlock(), _createBlock(_component_ScoreCard, {
              key: e.team.id,
              emotionScore: e.scores,
              team: e.team,
              canDelete: _ctx.userIsCompanyAdmin,
              onDeleteClicked: ($event: any) => (_ctx.showDelete(e))
            }, null, 8, ["emotionScore", "team", "canDelete", "onDeleteClicked"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.teamToDelete)
      ? (_openBlock(), _createBlock(_component_TeamChannelDeletionModal, {
          key: 2,
          team: _ctx.teamToDelete,
          onCompleted: _ctx.teamDeleted
        }, null, 8, ["team", "onCompleted"]))
      : _createCommentVNode("", true),
    (_ctx.viewOption == 'projects' && _ctx.projects.length)
      ? (_openBlock(), _createBlock(_component_ProjectsList, {
          key: 3,
          projects: _ctx.projects,
          onProjectDeleted: _ctx.projectDeleted
        }, null, 8, ["projects", "onProjectDeleted"]))
      : _createCommentVNode("", true),
    (_ctx.viewOption == 'projects' && _ctx.projects.length == 0 && _ctx.hasLoadedProjects)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No projects found. Create a project! "))
      : _createCommentVNode("", true),
    (!_ctx.hasLoadedProjects && !_ctx.hasLoadedDashboard && !_ctx.entries.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Loading... "))
      : _createCommentVNode("", true),
    (_ctx.viewOption == 'teams' && _ctx.entries.length == 0 && _ctx.hasLoadedDashboard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, " No teams found. Create a team! "))
      : _createCommentVNode("", true)
  ], 64))
}